import type { SiteConfig } from '@/types';

export const siteConfig: SiteConfig = {
  name: 'UGA Bienes Raíces',
  descriptor: 'Servicios inmobiliarios con respaldo jurídico.',
  lang: 'es-VE',
  country: 'Venezuela',
  defaultCurrency: 'USD',
  currencies: ['USD', 'EUR', 'VES'],
  hero: {
    title: 'Encuentra una propiedad con acompañamiento profesional y respaldo jurídico.',
    subtitle:
      'Compra, vende o alquila con una gestión inmobiliaria organizada, transparente y adaptada a tus necesidades.',
    ctaPrimary: 'Explorar propiedades',
    ctaSecondary: 'Quiero vender o alquilar',
    image: '/images/placeholders/hero-property.webp',
    imageAlt: 'Vista de propiedad residencial de alta calidad — imagen demostrativa',
  },
  contact: {
    // TODO: CONFIRMAR INFORMACIÓN
    email: undefined,
    phone: undefined,
    whatsapp: undefined,
    address: undefined,
    schedule: undefined,
  },
  social: {
    // TODO: CONFIRMAR INFORMACIÓN
    instagram: undefined,
    facebook: undefined,
    linkedin: undefined,
    youtube: undefined,
  },
  legalPartner: {
    name: 'Urribarrí, García & Asociados',
    description:
      'Firma legal vinculada institucionalmente. Los servicios jurídicos se prestan de forma separada e independiente.',
    url: undefined, // TODO: CONFIRMAR INFORMACIÓN
  },
  seo: {
    defaultTitle: 'UGA Bienes Raíces | Servicios inmobiliarios con respaldo jurídico',
    defaultDescription:
      'Compra, vende o alquila propiedades en Venezuela con acompañamiento profesional. Catálogo de inmuebles, proyectos y asesoría inmobiliaria.',
    siteUrl: import.meta.env.VITE_SITE_URL ?? 'https://TODO_DOMINIO.com',
    ogImage: '/images/brand/og-default.webp',
  },
};

export const demoNotice = 'DEMO — REEMPLAZAR ANTES DE PRODUCCIÓN';
